export interface CdnImageOptions {
  width?: number;
  height?: number;
  fit?: 'cover' | 'scale-down' | 'contain' | 'crop' | 'pad';
  quality?: number;
  onerror?: 'redirect';
  f?: 'auto';
  anim?: false;
}

export function getCdnImageUrl(
  originalImageUrl: string | null | undefined,
  options: CdnImageOptions,
): string | undefined {
  if (!originalImageUrl) return;

  options.quality ??= 100;
  options.fit ??= 'cover';
  options.onerror ??= 'redirect';
  options.f ??= 'auto';

  const paramString = Object.entries(options)
    .filter(([, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${value}`)
    .join(',');

  return originalImageUrl.replace(
    'https://cdn.bitskistatic.com/',
    `https://cdn.bitskistatic.com/cdn-cgi/image/${paramString}/`,
  );
}
